import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/admin.scss';
import { ApiHelper } from '../../apiHelper/ApiHelper';
import { SUBJECTS } from './adminConstants';
import VyukaTabs from '../../components/admin/VyukaTabs';

type Lesson = { id: string; number: number; title: string; difficulty: number; lines: number; questions: number; published: boolean };

export default function AdminLessons() {
    const [subject, setSubject] = useState(0);
    const [lessons, setLessons] = useState<Lesson[]>([]);
    const [loaded, setLoaded] = useState(false);
    const navigate = useNavigate();
    const api = new ApiHelper();

    useEffect(() => { setLoaded(false); load(); }, [subject]);

    async function load() {
        try { setLessons(await (await api.adminContentApi.lessons({ subject })).json()); } catch (x: any) { api.adminError(x); } finally { setLoaded(true); }
    }

    async function move(i: number, dir: number) {
        const j = i + dir;
        if (j < 0 || j >= lessons.length) return;
        const ids = lessons.map(l => l.id);
        [ids[i], ids[j]] = [ids[j], ids[i]];
        try { await api.adminContentApi.reorder({ ids }); await load(); } catch (x: any) { api.adminError(x); }
    }

    return (
        <div>
            <div className="adminHead">
                <div><h1>Výuka</h1><p>Lekce, studijní materiály a kvízy</p></div>
                <button className="aBtn" onClick={() => navigate("/admin/vyuka/new?subject=" + subject)}>+ Nová lekce</button>
            </div>

            <VyukaTabs />

            <div className="pills">
                {SUBJECTS.map(s => <span key={s.v} className={"pill" + (subject === s.v ? " on" : "")} onClick={() => setSubject(s.v)}>{s.l}</span>)}
            </div>

            <table className="aTable">
                <thead><tr><th>#</th><th>Název</th><th>Obtížnost</th><th>Materiály</th><th>Otázky</th><th>Pořadí</th></tr></thead>
                <tbody>
                    {lessons.map((l, i) => (
                        <tr key={l.id} onClick={() => navigate("/admin/vyuka/" + l.id)}>
                            <td>{l.number}</td>
                            <td>{l.title || <span className="muted">(bez názvu)</span>}{!l.published && <span className="draftBadge">Koncept</span>}</td>
                            <td>{l.difficulty}</td>
                            <td>{l.lines}</td>
                            <td>{l.questions}</td>
                            <td onClick={e => e.stopPropagation()}>
                                <span className="ord" onClick={() => move(i, -1)}>↑</span>
                                <span className="ord" onClick={() => move(i, 1)}>↓</span>
                            </td>
                        </tr>
                    ))}
                    {loaded && lessons.length === 0 && <tr><td colSpan={6} className="muted">Žádné lekce v tomto předmětu.</td></tr>}
                </tbody>
            </table>
        </div>
    );
}
